import clsx from 'clsx';
import type { FC } from 'react';
import { MEETING_ACCESS_POLICY_TITLE } from '../../../../utils/meetingAccessPolicy';
import type { PersonalMeetingTab, TabNavigationProps } from '../../types';

const TAB_DEFINITIONS: Array<{ id: PersonalMeetingTab; label: string; shortLabel: string }> = [
  { id: 'meeting-details', label: 'Meeting Details', shortLabel: 'Details' },
  { id: 'lobby-room', label: 'Lobby Room', shortLabel: 'Lobby' },
  { id: 'security-options', label: MEETING_ACCESS_POLICY_TITLE, shortLabel: 'Access' },
];

export const TabNavigation: FC<TabNavigationProps> = ({ activeTab, onChange }) => {
  return (
    <div className="personal-meetings-modal__tabs">
      {TAB_DEFINITIONS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={clsx('personal-meetings-modal__tab', {
            'personal-meetings-modal__tab--active': activeTab === tab.id,
          })}
        >
          <span className="personal-meetings-modal__tab-label">{tab.label}</span>
          <span className="personal-meetings-modal__tab-label--short">{tab.shortLabel}</span>
        </button>
      ))}
    </div>
  );
};
